import React, { useState, Fragment, useEffect } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Formulario from 'components/formulario';
import { tiposMedios } from 'constantes/globalsStates';
import { Add, Visibility } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const TelevisionYRadio = ({ tipodeMedio, agregarAlListado }) => {
    const [listadoTipoTv] = useState([{ id: 1, name: 'TV por cable' }, { id: 2, name: 'TV abierta' }, { id: 3, name: 'TV satelital' }]);
    const [mostrarAvisoRenovacion, setMostrarAvisoRenovacion] = useState(false);
    const fechaLimiteRenovacion = new Date(2027, 7, 31);

    useEffect(() => {
        validateMediaType(tipodeMedio);
    }, [tipodeMedio]);

    const validateMediaType = (tipodeMedio) => {
        setElements(prev => {
            const n = { ...prev };

            // Reset esArrendatario section
            n.esArrendatario = { ...prev.esArrendatario, value: null };
            n.FechaFinal = { ...prev.FechaFinal, showInputDate: false, value: null };
            n.contratoArrendatario = { ...prev.contratoArrendatario, showInputFile: false, validators: { ...prev.contratoArrendatario.validators, required: false }, value: null };
            n.autorizacionProPolitica = { ...prev.autorizacionProPolitica, mostrarBotonRadio: false };

            if (tipodeMedio.id === tiposMedios.TELEVISION.id) {
                n.clasificacionModulada = { ...prev.clasificacionModulada, showTitleForm: false };
                n.tipoClasificacion = { ...prev.tipoClasificacion, mostrarBotonRadio: false, isRequired: false };
                n.tipoTv = { ...prev.tipoTv, showSelectAutoComplete: true, pattern: '^[1-9][0-9]*$', value: { id: 1, name: 'TV por cable' } };

                // Apply TV cable (type 1) defaults
                n.uncosu = { ...prev.uncosu, showTitleForm: true, title: 'Datos del UNCOSU' };
                n.numeroCertificacion = { ...prev.numeroCertificacion, showInputFormControl: true, pattern: '^[\\-0-9_\\/|a-zA-Z]+$', value: '' };
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: true, pattern: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: true, label: 'Ingrese constancia del uncosu *', validators: { ...prev.constanciaUncosu.validators, required: true } };
                n.facilidadSatelital = { ...prev.facilidadSatelital, mostrarBotonRadio: false, isRequired: false, value: '' };
            } else if (tipodeMedio.id === tiposMedios.RADIO.id) {
                n.clasificacionModulada = { ...prev.clasificacionModulada, showTitleForm: true };
                n.tipoClasificacion = { ...prev.tipoClasificacion, mostrarBotonRadio: true, isRequired: true };
                n.tipoTv = { ...prev.tipoTv, showSelectAutoComplete: false, pattern: '', value: null };
                n.uncosu = { ...prev.uncosu, showTitleForm: true, title: 'Datos del SIT' };
                n.numeroCertificacion = { ...prev.numeroCertificacion, showInputFormControl: true, pattern: '^[\\-0-9_\\/|a-zA-Z]+$', value: '' };
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: true, pattern: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: true, label: 'Ingrese constancia del sit *', validators: { ...prev.constanciaUncosu.validators, required: true } };
                n.facilidadSatelital = { ...prev.facilidadSatelital, mostrarBotonRadio: false, isRequired: false };
            }

            return n;
        });
    };

    const handleTipoTV = (item) => {
        const value = Number(item.target.value);
        if (!value) return;

        setElements(prev => {
            const n = { ...prev };
            // Persist the selection so Formulario's useEffect reset respects the user's choice
            n.tipoTv = { ...prev.tipoTv, value: { id: value, name: item.target.text || prev.tipoTv?.value?.name || '' } };

            if (value === 3) {
                // TV satelital: hide cert/date, show facilidad satelital
                n.uncosu = { ...prev.uncosu, showTitleForm: true, title: 'Licencia de usuario de operacion de facilidades satelitales' };
                n.numeroCertificacion = { ...prev.numeroCertificacion, showInputFormControl: false, pattern: '', value: '' };
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: false, pattern: '', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: false, validators: { ...prev.constanciaUncosu.validators, required: false }, value: '' };
                n.facilidadSatelital = { ...prev.facilidadSatelital, mostrarBotonRadio: true, isRequired: true, value: '' };
            } else {
                // TV cable (1) or TV abierta (2): show cert/date, hide facilidad satelital
                n.uncosu = { ...prev.uncosu, showTitleForm: true };
                n.numeroCertificacion = { ...prev.numeroCertificacion, showInputFormControl: true, pattern: '^[\\-0-9_\\/|a-zA-Z]+$', value: '' };
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: true, pattern: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: true, validators: { ...prev.constanciaUncosu.validators, required: true } };
                n.facilidadSatelital = { ...prev.facilidadSatelital, mostrarBotonRadio: false, isRequired: false, value: '' };

                if (value === 1) {
                    n.constanciaUncosu = { ...n.constanciaUncosu, label: 'Ingrese constancia del uncosu *' };
                    n.uncosu = { ...n.uncosu, title: 'Datos del UNCOSU' };
                } else if (value === 2) {
                    n.constanciaUncosu = { ...n.constanciaUncosu, label: 'Ingrese constancia del sit *' };
                    n.uncosu = { ...n.uncosu, title: 'Datos del SIT' };
                }
            }

            return n;
        });
    };

    const handleActionEsArrendatario = (_, value) => {
        if (!value) return;

        setElements(prev => {
            const n = { ...prev };

            n.esArrendatario = { ...prev.esArrendatario, value };
            n.autorizacionProPolitica = { ...prev.autorizacionProPolitica, mostrarBotonRadio: true, value: null };

            if (value === '0') {
                n.FechaFinal = { ...prev.FechaFinal, showInputDate: false, pattern: '', value: null };
                n.contratoArrendatario = { ...prev.contratoArrendatario, showInputFile: false, validators: { ...prev.contratoArrendatario.validators, required: false } };
            } else {
                n.FechaFinal = { ...prev.FechaFinal, showInputDate: true, pattern: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.contratoArrendatario = { ...prev.contratoArrendatario, showInputFile: true, validators: { ...prev.contratoArrendatario.validators, required: true }, value: null };
            }

            return n;
        });
    };

    const handleActionFacilidadSatelital = (_, value) => {
        if (!value) return;

        setElements(prev => {
            const n = { ...prev };

            n.facilidadSatelital = { ...prev.facilidadSatelital, value };

            if (value === '0') {
                n.numeroCertificacion = { ...prev.numeroCertificacion, showInputFormControl: false, pattern: '', value: '' };
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: false, pattern: '', value: null };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: false, validators: { ...prev.constanciaUncosu.validators, required: false } };
            } else {
                n.fechaVigencia = { ...prev.fechaVigencia, showInputDate: true, pattern: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$', value: null, isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
                n.constanciaUncosu = { ...prev.constanciaUncosu, showInputFile: true, validators: { ...prev.constanciaUncosu.validators, required: true }, label: 'Ingrese constancia de licencia de usuario *', value: null };
            }

            return n;
        });
    };

    const changeValueToSelect = (element, nameShowSelectAutoComplete, showElement, pattern, value = '') => {
        setElements(prev => {
            const n = { ...prev };
            n[element] = { ...prev[element], [nameShowSelectAutoComplete]: showElement, pattern, value };
            if (element === 'fechaVigencia') {
                n[element] = { ...n[element], isError: false, errorMessages: ['fecha dd/MM/yyyy'] };
            }
            return n;
        });
    };

    const [responseData, setResponseData] = useState({
        errorType: '',
        messageType: '',
        openResponse: false,
    });

    const normalizarFecha = (fecha) => {
        if (!fecha) return null;

        if (fecha instanceof Date && !Number.isNaN(fecha.getTime())) {
            return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        }

        if (typeof fecha === 'string') {
            const valor = fecha.trim();
            const match = valor.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);

            if (match) {
                const day = Number(match[1]);
                const month = Number(match[2]) - 1;
                const year = Number(match[3]);
                const parsed = new Date(year, month, day);

                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
                return null;
            }

            const parsed = new Date(valor);
            if (!Number.isNaN(parsed.getTime())) {
                return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
            }
        }

        return null;
    };

    const obtenerHoy = () => {
        const ahora = new Date();
        return new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
    };

    const validarFechaFinal = (event) => {
        const fechaSeleccionada = event.target.value;

        if (!fechaSeleccionada) {
            setElements(prev => ({
                ...prev,
                FechaFinal: { ...prev.FechaFinal, value: null, isError: true, errorMessages: 'Debe ingresar fecha final de arrendamiento.' },
            }));
            return;
        }

        const hoy = obtenerHoy();
        const fecha = normalizarFecha(fechaSeleccionada);

        if (!fecha || fecha < hoy) {
            setElements(prev => ({
                ...prev,
                FechaFinal: { ...prev.FechaFinal, value: fechaSeleccionada, isError: true, errorMessages: 'Contrato de arrendamiento vencido.' },
            }));
            setResponseData({
                errorType: 'error',
                messageType: 'Contrato de arrendamiento vencido.',
                openResponse: true,
            });
            return;
        }

        setElements(prev => ({
            ...prev,
            FechaFinal: { ...prev.FechaFinal, value: fechaSeleccionada, isError: false, errorMessages: ['fecha dd/MM/yyyy'] },
        }));
    };

    const validarFechaVigencia = (event) => {
        const value = event?.target?.value;

        setElements(prev => {
            if (!prev?.fechaVigencia?.showInputDate) return prev;

            if (!value) {
                setMostrarAvisoRenovacion(false);
                return { ...prev, fechaVigencia: { ...prev.fechaVigencia, value: null, isError: true, errorMessages: ['Debe ingresar fecha de vigencia'] } };
            }

            const fechaIngresada = normalizarFecha(value);
            if (!fechaIngresada) {
                setMostrarAvisoRenovacion(false);
                return { ...prev, fechaVigencia: { ...prev.fechaVigencia, value, isError: true, errorMessages: ['Fecha de vigencia inválida'] } };
            }

            const hoy = obtenerHoy();
            const esVencida = fechaIngresada < hoy;
            setMostrarAvisoRenovacion(!esVencida && fechaIngresada < fechaLimiteRenovacion);

            return {
                ...prev,
                fechaVigencia: {
                    ...prev.fechaVigencia,
                    value,
                    isError: esVencida,
                    errorMessages: esVencida ? ['Certificación y Registro vencido'] : ['fecha dd/MM/yyyy'],
                },
            };
        });
    };

    const [elements, setElements] = useState(() => {
        const elementos = {
        tipoTv: {
            idelement: 'tipoTv', value: null, label: 'Seleccione el tipo de television *', pattern: '', validators: ['required'],
            errorMessages: ['Seleccione el tipo de television'], isError: false, elementType: 'autoCompletar', list: listadoTipoTv, handler: handleTipoTV,
            autoFocus: false, showSelectAutoComplete: false, width: '50%'
        },

        clasificacionModulada: {
            idelement: 'clasificacionModulada', title: 'Clasificacion modulada', position: 'center', value: '', isError: false, elementType: 'titulo', showTitleForm: true, name: 'clasificacionModulada',
        },

        tipoClasificacion: {
            idelement: 'tipoClasificacion', value: null, label: 'Seleccione la clasificacion modulada *', isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opcion'],
            options: [{ value: '4', label: 'RADIO AM' }, { value: '5', label: 'RADIO FM' }, { value: '10', label: 'RADIO AM Y FM' }], disabled: false, handleAction: undefined, isRequired: false, width: '50%'
        },

        uncosu: {
            idelement: 'uncosu', title: '', position: 'center', value: '', isError: false, elementType: 'titulo', showTitleForm: true, name: 'uncosu',
        },

        facilidadSatelital: {
            idelement: 'facilidadSatelital', value: null, label: 'Tiene licencia de usuario de operacion de facilidades satelitales? *', isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opcion'],
            options: [{ value: '0', label: 'No' }, { value: '1', label: 'Si' }], disabled: false, handleAction: handleActionFacilidadSatelital, mostrarBotonRadio: false, isRequired: false, width: '50%'
        },

        numeroCertificacion: {
            idelement: 'numeroCertificacion', value: '', label: 'Numero de certificacion y registro *', pattern: '', validators: ['required'],
            errorMessages: ['El campo es requerido'], isError: false, elementType: 'texto', name: 'numeroCertificacion', disabled: false, showInputFormControl: false, width: '100%'
        },
        fechaVigencia: {
            idelement: 'fechaVigencia', value: null, label: 'Fecha de vigencia hasta *', pattern: '',
            validators: ['required'], errorMessages: ['fecha dd/MM/yyyy'], isError: false, elementType: 'fecha',
            disabled: false, showInputDate: false, disablePast: true, minDate: new Date(), manejadorDeCambio: validarFechaVigencia, width: '50%'
        },
        constanciaUncosu: {
            idelement: 'constanciaUncosu', value: null, label: '',
            validators: { required: true, size: '10 MB' }, errorMessages: 'Por favor debe adjuntar lo solicitado', isError: false, elementType: 'archivo', disabled: false, name: 'constanciaUncosu', fileWidth: true, src: '', multiple: false, accept: '.pdf', showInputFile: false, showInMovil: true, type: 'file', showButtonEditDocument: true, firstTitle: 'constanciaUncosu', iconButton: <Visibility />, handleVisualization: () => { }, fileType: 'pdf', width: '50%'
        },

        contratoArrendatarioTitle: {
            idelement: 'contratoArrendatarioTitle', title: 'Datos del contrato de arrendamiento', position: 'center', value: '', isError: false, elementType: 'titulo', showTitleForm: true, name: 'contratoArrendatarioTitle',
        },
        esArrendatario: {
            idelement: 'esArrendatario', value: null, label: 'Es arrendatario? *', isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opcion'],
            options: [{ value: '0', label: 'No' }, { value: '1', label: 'Si' }], disabled: false, handleAction: handleActionEsArrendatario, isRequired: true, width: '100%'
        },
        FechaFinal: {
            idelement: 'FechaFinal',
            value: null,
            label: 'Fecha final *',
            pattern: '',
            validators: ['required'],
            errorMessages: ['fecha dd/MM/yyyy'],
            isError: false,
            elementType: 'fecha',
            disabled: false,
            showInputDate: false,
            minDate: new Date(),
            manejadorDeCambio: validarFechaFinal,
            width: '80%'
        },
        autorizacionProPolitica: {
            idelement: 'autorizacionProPolitica', value: null, label: 'Tiene autorizacion para transmitir Pro Politica? *', isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opcion'],
            options: [{ value: '0', label: 'No' }, { value: '1', label: 'Si' }], disabled: false, handleAction: undefined, mostrarBotonRadio: false, isRequired: true, width: '100%'
        },
        contratoArrendatario: {
            idelement: 'contratoArrendatario', value: null, label: 'Ingrese el contrato *',
            validators: { required: true, size: '10 MB' }, errorMessages: 'Por favor debe adjuntar lo solicitado', isError: false, elementType: 'archivo', disabled: false, name: 'contratoArrendatario', fileWidth: true, src: '', multiple: false, accept: '.pdf', showInputFile: false, showInMovil: true, type: 'file', showButtonEditDocument: true, firstTitle: 'contratoArrendatario', iconButton: <Visibility />, handleVisualization: () => { }, fileType: 'pdf', width: '80%'
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    useEffect(() => {
        if (!elements?.fechaVigencia?.showInputDate) {
            setMostrarAvisoRenovacion(false);
            return;
        }

        const value = elements?.fechaVigencia?.value;
        if (!value) {
            setMostrarAvisoRenovacion(false);
            return;
        }

        const fechaIngresada = normalizarFecha(value);
        if (!fechaIngresada) {
            setMostrarAvisoRenovacion(false);
            return;
        }

        const hoy = obtenerHoy();

        if (fechaIngresada < hoy) {
            setMostrarAvisoRenovacion(false);
            return;
        }

        setMostrarAvisoRenovacion(fechaIngresada < fechaLimiteRenovacion);
    }, [elements?.fechaVigencia?.value, elements?.fechaVigencia?.showInputDate]);

    const addToTheList = async (dataForm) => {
        const hoy = obtenerHoy();

        if (elements?.fechaVigencia?.showInputDate) {
            const fechaVigencia = normalizarFecha(dataForm?.fechaVigencia);

            if (!dataForm?.fechaVigencia) {
                setResponseData({
                    errorType: 'warning',
                    messageType: 'Debe ingresar fecha de vigencia',
                    openResponse: true,
                });
                return;
            }

            if (!fechaVigencia || fechaVigencia < hoy) {
                setResponseData({
                    errorType: 'warning',
                    messageType: 'Certificación y Registro vencido',
                    openResponse: true,
                });
                return;
            }
        }

        if (dataForm?.esArrendatario === '1') {
            const fechaFinal = normalizarFecha(dataForm?.FechaFinal);

            if (!dataForm?.FechaFinal) {
                setResponseData({
                    errorType: 'warning',
                    messageType: 'Debe ingresar fecha final de arrendamiento.',
                    openResponse: true,
                });
                return;
            }

            if (!fechaFinal || fechaFinal < hoy) {
                setResponseData({
                    errorType: 'warning',
                    messageType: 'Contrato de arrendamiento vencido.',
                    openResponse: true,
                });
                return;
            }
        }

        agregarAlListado(dataForm);
        const elementosReiniciados = functions.reiniciarEstadoDelFormulario({ ...elements });
        setElements({ ...elementosReiniciados });
    };

    const [buttonList] = React.useState({
        addToTheList: {
            label: 'Agregar al listado', icon: <Add />, callback: addToTheList, loading: false, size: 'medium',
            background: 'linear-gradient(45deg, #ffcc00 30%, #d9bd09 90%)', border: '0px', borderRadius: '3',
            boxShadow: '0 3px 5px 2px rgba(168, 142, 50, .3)', color: 'white', height: 37, padding: '0 30px', disabled: false, isCancel: false,
        }
    });

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                        responseData={responseData}
                    />
                    {mostrarAvisoRenovacion && (
                        <Typography variant='body2' style={{ color: '#205690', fontWeight: 600, marginTop: 8 }}>
                            Aviso: la fecha ingresada es anterior al 31 de agosto de 2027. El registro debera renovarse oportunamente para evitar quedar excluido.
                        </Typography>
                    )}
                </CardContent>
            </Card>
        </Fragment>
    );
};

export default TelevisionYRadio;